// extracted by mini-css-extract-plugin
module.exports = {"ScrollArea":"_2atx_Q","hasOverflownX":"JJgKN4","AlignLeft":"b_U91r","AlignRight":"_1NM8g8"};